import { useCallback, useRef } from 'react';
import { useLanguageContext } from '../../Form';
import { TemplateLanguageProviderViewProps } from '../types';

export function useTemplateLanguageController(
  config: TemplateLanguageProviderViewProps['config']
) {
  const language = useLanguageContext();
  const configRef = useRef(config);

  const getTranslate = useCallback(
    (key: string) => {
      return (
        configRef.current[key]?.[language?.key || 'en'] ||
        configRef.current[key]?.en ||
        key
      );
    },
    [language, language?.key]
  );

  const getTranslateByLang = useCallback((key: string, lang: string) => {
    return configRef.current[key]?.[lang] || key;
  }, []);

  return { getTranslate, getTranslateByLang };
}
